import { render, staticRenderFns } from "./interfaces.vue?vue&type=template&id=aec5a048&scoped=true&"
import script from "./interfaces.vue?vue&type=script&lang=js&"
export * from "./interfaces.vue?vue&type=script&lang=js&"
import style0 from "./interfaces.vue?vue&type=style&index=0&id=aec5a048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec5a048",
  null
  
)

export default component.exports